var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint consistent-return: 0 */

import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';
import isFinite from 'lodash/isFinite';

import defaultValues from './object-defaults';

/**
 * Object input
 *
 * The root object should at least an `id` and `type`. The object will be passed
 * as-if if those two fields are missing.
 *
 * Any field containing an object or array will be formated recursivly.
 *
 * Example object:

 * ```
 * {
 * type: 'Listing',
 * id: 'search-query',
 * items: [{
 * type: 'ClassifiedAd',
 * id: 'ad-123'
 * }]
 *}
 *```
 */


function rewriteObjectType() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var objectType = type.toLowerCase();
  if (objectType === 'classifiedad') {
    objectType = 'classified';
  }
  if (objectType === 'notificationcontent') {
    objectType = 'notification';
  }
  return objectType;
}

export function sdrn(id, providerId, type) {
  if ((isString(id) || isFinite(id)) && isString(providerId) && isString(type)) {
    var contentType = rewriteObjectType(type);
    return 'sdrn:' + providerId + ':' + contentType + ':' + id;
  }
}

function formatUIElement(_ref) {
  var object = _ref.object,
      target = _ref.target,
      provider = _ref.provider;

  var id = object.id,
      type = object.type,
      custom = object.custom,
      rest = _objectWithoutProperties(object, ['id', 'type', 'custom']);

  var _ref2 = target || {},
      targetId = _ref2.id,
      targetType = _ref2.type;

  var _ref3 = provider || {},
      providerId = _ref3.id;

  return Object.assign({
    '@id': 'sdrn:' + providerId + ':' + rewriteObjectType(targetType) + ':' + targetId + ':element:' + id,
    '@type': type,
    'spt:custom': custom
  }, rest);
}

function formatDefaultObject(_ref4) {
  var _ref4$object = _ref4.object,
      object = _ref4$object === undefined ? {} : _ref4$object,
      _ref4$provider = _ref4.provider,
      provider = _ref4$provider === undefined ? {} : _ref4$provider;

  var id = object.id,
      _object$type = object.type,
      type = _object$type === undefined ? 'Content' : _object$type,
      custom = object.custom,
      rest = _objectWithoutProperties(object, ['id', 'type', 'custom']);

  var providerId = provider.id;


  var fullId = sdrn(id, providerId, type);
  var base = fullId ? {
    '@id': fullId,
    '@type': type
  } : {};
  if (custom) {
    base['spt:custom'] = custom;
  }
  return Object.assign(base, rest);
}

function formatAccount(_ref5) {
  var object = _ref5.object;

  var id = object.id,
      _object$realm = object.realm,
      realm = _object$realm === undefined ? 'schibsted.com' : _object$realm,
      type = object.type,
      custom = object.custom,
      rest = _objectWithoutProperties(object, ['id', 'realm', 'type', 'custom']);

  if (!id) {
    return;
  }

  return Object.assign({
    '@id': 'sdrn:' + realm + ':user:' + id,
    '@type': 'Account',
    accountId: id
  }, rest);
}

var objectFormatterMapping = {
  UIElement: formatUIElement,
  Account: formatAccount
};

function getFormatter(type) {
  return objectFormatterMapping[type] || formatDefaultObject;
}

export default function formatObject(data) {
  var _ref6 = data || {},
      _ref6$object = _ref6.object,
      objectInput = _ref6$object === undefined ? {} : _ref6$object;

  var evaluatedObjectInput = Object.keys(objectInput).reduce(function (accl, key) {
    var prop = objectInput[key];
    if (isArray(prop)) {
      return _extends({}, accl, _defineProperty({}, key, prop.map(function (o) {
        if (isPlainObject(o)) {
          return formatObject(Object.assign({}, data, { object: o }));
        }
        return o;
      })));
    } else if (isPlainObject(prop)) {
      return _extends({}, accl, _defineProperty({}, key, formatObject(Object.assign({}, data, { object: prop }))));
    }
    return _extends({}, accl, _defineProperty({}, key, prop));
  }, {});

  return getFormatter(objectInput.type)(Object.assign({}, data, { object: evaluatedObjectInput }));
}

export var defaultValue = defaultValues;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-event-builders/dist/ejs/objects.js
// module id = 528
// module chunks = 0